// Consentimento de cookies (LGPD, 24/10/2026).
//
// Essenciais (login, preferências, antifraude) sempre funcionam. Duas
// categorias dependem de aceite: `medicao` (Google Analytics 4) e `anuncios`
// (Meta Pixel). Quem carrega/desliga os scripts é o public/index.html
// (window.__toaCookies), que só existe no domínio toalugando.com.br — no app
// Android e em outros endereços não há rastreador nenhum.

export const CHAVE_COOKIES = 'toalugando_cookies_v1';
export const EVENTO_ABRIR_COOKIES = 'toalugando:cookies:abrir';

export const lerConsentimento = () => {
  try {
    const v = JSON.parse(localStorage.getItem(CHAVE_COOKIES) || 'null');
    return v && typeof v === 'object' ? v : null;
  } catch (e) { return null; }
};

export const salvarConsentimento = ({ medicao = false, anuncios = false } = {}) => {
  const v = { medicao: !!medicao, anuncios: !!anuncios, em: new Date().toISOString(), versao: 1 };
  try { localStorage.setItem(CHAVE_COOKIES, JSON.stringify(v)); } catch (e) { /* sem armazenamento: vale só nesta visita */ }
  try { window.__toaCookies?.aplicar(v); } catch (e) { /* rastreadores fora do ar não travam o site */ }
  return v;
};

/** Há rastreadores para consentir? Só no site em produção (e no dev, para testar a barra). */
export const temRastreadores = () => {
  try {
    if (window.__toaCookies) return true;
    return process.env.NODE_ENV === 'development';
  } catch (e) { return false; }
};

/** Reabre a barra (link "Preferências de cookies" na Política de Privacidade). */
export const abrirPreferenciasCookies = () => {
  try { window.dispatchEvent(new Event(EVENTO_ABRIR_COOKIES)); } catch (e) { /* ok */ }
};
